<template>
  <div id="app">  
    <keep-alive>
      <router-view :key="key" v-if="isRouterAlive" v-cloak/>
    </keep-alive>
  </div>
</template>

<script>  
export default {
  name: 'App',
  computed: {
    key() {
      return this.$route.path + Math.random()
    }
  },
  provide(){
    return{
      reload:this.reload
    }
  },
  data(){
    return {
      isRouterAlive:true
    }
  },
  methods:{
    reload(){
      this.isRouterAlive = false
      this.$nextTick(function(){
          this.isRouterAlive = true
      })
    }
  }
}
</script> 
<style>  
[v-cloak] {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue